/**
 * External dependencies
 */
import React from "react";

function Spinner() {
	return <div className="spinner" />;
}

export default Spinner;
